import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import NavBar from "../components/NavBar/NavBar";
import LogSignInForm from "../components/Authentication/LoginSignup";
const Login = () => {
  return (
    <div>
      <NavBar />
      <LogSignInForm />
    </div>
  );
};

export default Login;
